module.exports = __webpack_public_path__ + "img/NextAdmin.2338e867.svg";